import PropTypes from "prop-types";
import { useState } from "react";
import { Send } from "lucide-react";

// Fallback only. The real limit is ASKAI_MAX_MESSAGE_CHARS, served
// through /askai/config/ and passed down as maxChars — the two used to be
// hardcoded separately, so raising the server limit changed nothing here.
const DEFAULT_MAX_CHARS = 4000;

function AskAiComposer({ onSend, disabled, maxChars }) {
  const [value, setValue] = useState("");

  const limit = maxChars || DEFAULT_MAX_CHARS;
  const trimmed = value.trim();
  const canSend = trimmed.length > 0 && trimmed.length <= limit && !disabled;

  const submit = () => {
    if (!canSend) return;
    onSend(trimmed);
    setValue("");
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      submit();
    }
  };

  return (
    <div className="border-t border-border p-3">
      <div className="flex items-end gap-2 rounded-xl border border-border-input bg-surface-sunken px-3 py-2 focus-within:border-accent">
        <label htmlFor="askai-composer-input" className="sr-only">
          Message Ask AI
        </label>
        <textarea
          id="askai-composer-input"
          value={value}
          onChange={(event) => setValue(event.target.value)}
          onKeyDown={handleKeyDown}
          rows={2}
          maxLength={limit}
          disabled={disabled}
          placeholder="Ask about your properties, tasks, or activity…"
          className="max-h-32 min-h-[48px] flex-1 resize-none bg-transparent text-sm text-text-primary placeholder:text-text-muted focus:outline-none disabled:opacity-60"
        />
        <button
          type="button"
          onClick={submit}
          disabled={!canSend}
          aria-label="Send message"
          className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-accent text-accent-ink transition disabled:cursor-not-allowed disabled:opacity-40 focus:outline-none focus:ring-2 focus:ring-accent focus:ring-offset-2 focus:ring-offset-surface-sunken"
        >
          <Send size={15} aria-hidden="true" />
        </button>
      </div>
    </div>
  );
}

AskAiComposer.propTypes = {
  onSend: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  maxChars: PropTypes.number,
};

AskAiComposer.defaultProps = {
  disabled: false,
  maxChars: DEFAULT_MAX_CHARS,
};

export default AskAiComposer;
